
<template >
  <div class="login-page">

    <div class=""
         style="text-align:center;padding-top:6rem">
      <div>
        <i class="fa fa-link"
           style="font-size:4em;color:#07c160;"></i>
      </div>
      <div style="padding:20px">
        <span>用户帐号{{login}}({{nickName}})即将绑定微信帐号，点击下方“绑定”按钮进行绑定</span>
      </div>
      <div style="padding-top:10px">
        <el-button type="success"
                   v-if="!isOk"
                   @click="onSubmit"
                   style="width:90%;height:3rem;font-size:1.5rem">绑定</el-button>
        <el-button type="success"
                   v-if="isOk"
                   disabled
                   style="width:90%;height:3rem;font-size:1.5rem">绑定成功</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import util from '@/libs/util'
export default {
  title: '自定义列模板',
  index: 14,
  data () {
    return {
      isOk: false,
      login: this.$route.query.login,
      nickName: this.$route.query.nickName,
      openId: this.$route.query.openId
    }
  },
  methods: {
    ...mapActions('d2admin/user', [
      'doUserBindWechat'
    ]),
    onSubmit () {

      this.loading = this.$loading({
        fullscreen: true,
        text: '加载中',
        background: "rgba(0, 0, 0, 0.6)"
      })
      this.doUserBindWechat({
        vm: this,
        login: this.login,
        nickName: this.nickName,
        openId: this.openId
      })
    }
  }
}
</script>
<style lang="scss">
@import '../login/style.scss';
.el-button--success {
  color: #fff;
  background-color: #07c160;
  border-color: #07c160;
}
.el-button--success:focus,
.el-button--success:hover {
  background: #01b468;
  border-color: #01b468;
  color: #fff;
}
.el-message-box {
  width: 80%;
}
.el-button--success.is-disabled,
.el-button--success.is-disabled:active,
.el-button--success.is-disabled:focus,
.el-button--success.is-disabled:hover {
  color: #fff;
  background-color: #01b468;
  border-color: #01b468;
}
</style>

